import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';

import Preview from './Preview';
import { FORM_KEYS } from '../../form-designer/constants/form-manager.constants';
import { FormContext } from '../../form-designer/context';
import Link from '../Link/Link';

const useStyles = makeStyles({
  previewLinkContainer: {
    display: 'flex',
  },
  linkWrapper: {
    padding: '3px 2px 1px',
  },
});

const PreviewLink = ({ ...props }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const handleMouseEnter = (event) => {
    event.stopPropagation();

    if (!open) {
      setOpen(true);
    }
  };

  const handleMouseLeave = (event) => {
    event.stopPropagation();

    setOpen(false);
  };

  return (
    <div className={classes.previewLinkContainer}>
      <div className={classes.linkWrapper}>
        <Link {...props} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
      </div>
      {open && (
        <FormContext.Provider value={FORM_KEYS.LINK_PREVIEW}>
          <Preview {...props} />
        </FormContext.Provider>
      )}
    </div>
  );
};

export default PreviewLink;
